import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';

import { substituteUrl } from 'shared/utils/substituteUrl';

import logo from 'assets/images/logo.svg';

import {
  STATIC_PAGE_URL,
  RESOURCE_DETAIL_URL,
  ENTERPRISE_PRODUCTS_URL
} from 'global-constants';

import classnames from 'classnames';
import styles from './styles.module.scss';
import { privateStaticPages } from './constants';

class Footer extends Component {
  render() {
    const {
      staticPages,
      className,
      resourcesClassName,
      withTopBorder = true
    } = this.props;

    return (
      <React.Fragment>
        <footer
          className={classnames(
            styles.footerWrapper,
            { [styles.withTopBorder]: withTopBorder },
            className
          )}>
          <div className="container">
            <div className={styles.aboutUsContainer}>
              <div
                className={classnames(
                  styles.unissuLogo,
                  styles.item,
                  styles.link
                )}>
                <img src={logo} alt="Logo" />
              </div>
              <div className={styles.content}>
                <div className={styles.aboutMenu}>
                  <div className={styles.row}>
                    {staticPages.map(staticPage => {
                      return (
                        !_.includes(privateStaticPages, staticPage.label) && (
                          <Link
                            key={staticPage.value}
                            className={classnames(styles.item, styles.link)}
                            to={substituteUrl(STATIC_PAGE_URL, {
                              pageSlug: staticPage.value
                            })}>
                            {staticPage.label}
                          </Link>
                        )
                      );
                    })}

                    <Link
                      className={classnames(styles.item, styles.link)}
                      to={ENTERPRISE_PRODUCTS_URL}>
                      Enterprise
                    </Link>
                    <Link
                      className={classnames(styles.item, styles.link)}
                      to={substituteUrl(RESOURCE_DETAIL_URL, {
                        resourceSlug: 'what-is-proptech'
                      })}>
                      What is PropTech?
                    </Link>
                  </div>
                </div>
                <div className={styles.copyrightLabel}>
                  Copyright 2020 Unissu Ltd. All rights reserved. No part of
                  this site may be reproduced without our written permission.
                </div>
              </div>
              <div className={styles.description}>
                <div className={classnames(styles.title, styles.item)}>
                  Information
                </div>
                <div className={classnames(styles.item)}>
                  Unissu is the world’s PropTech and ReTech marketplace. Save
                  time and access the best information about how technology is
                  changing the property industry so you can choose the best
                  solutions for your business.
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div
          className={classnames(styles.resourceContainer, resourcesClassName)}>
          <div className={styles.title}>PropTechs by Country:</div>
          <div className={styles.row}>
            <Link
              className={classnames(styles.item, styles.link)}
              to={substituteUrl(RESOURCE_DETAIL_URL, {
                resourceSlug: 'proptech-in-australia'
              })}>
              Australia
            </Link>
            <Link
              className={classnames(styles.item, styles.link)}
              to={substituteUrl(RESOURCE_DETAIL_URL, {
                resourceSlug: 'proptech-in-germany'
              })}>
              Germany
            </Link>
            <Link
              className={classnames(styles.item, styles.link)}
              to={substituteUrl(RESOURCE_DETAIL_URL, {
                resourceSlug: 'proptech-in-france'
              })}>
              France
            </Link>
            <Link
              className={classnames(styles.item, styles.link)}
              to={substituteUrl(RESOURCE_DETAIL_URL, {
                resourceSlug: 'proptech-in-netherlands'
              })}>
              Netherlands
            </Link>
            <Link
              className={classnames(styles.item, styles.link)}
              to={substituteUrl(RESOURCE_DETAIL_URL, {
                resourceSlug: 'proptech-in-the-uk'
              })}>
              U.K.
            </Link>
            <Link
              className={classnames(styles.item, styles.link)}
              to={substituteUrl(RESOURCE_DETAIL_URL, {
                resourceSlug: 'proptech-retech-in-the-usa'
              })}>
              USA
            </Link>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const staticPages = _.get(
    state,
    'constants.constants.static_pages.STATIC_PAGE_TYPE_CHOICES',
    []
  );
  return { staticPages };
};

const mapDispatchToProps = {
  push
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);
